import { render, staticRenderFns } from "./form-component.vue?vue&type=template&id=68cab0a5&scoped=true"
import script from "./form-component.vue?vue&type=script&lang=js"
export * from "./form-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cab0a5",
  null
  
)

export default component.exports